import { render } from "./index.vue?vue&type=template&id=27a577ca&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=27a577ca&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a577ca"]])

export default __exports__